import { render, staticRenderFns } from "./MenuSelectedMessages.vue?vue&type=template&id=4323dc94&scoped=true&"
import script from "./MenuSelectedMessages.vue?vue&type=script&lang=js&"
export * from "./MenuSelectedMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323dc94",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemAvatar,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4323dc94')) {
      api.createRecord('4323dc94', component.options)
    } else {
      api.reload('4323dc94', component.options)
    }
    module.hot.accept("./MenuSelectedMessages.vue?vue&type=template&id=4323dc94&scoped=true&", function () {
      api.rerender('4323dc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuSelectedMessages.vue"
export default component.exports